<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/crs/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  let channel = {"108":"108","72":"72","36":"36"};
  let status = {"0":"停用","1":"正常"};
  export default {
    name: 'config',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete") {
            this.dataChanage(URL.pushMsgConfig.del, {id: row.id}, res => {
                if (res.code == 0) {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                } else {
                    this.$message.error(res.message);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t("common.search") == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName || window.$t("common.addNew") == clickName){
           this.$refs.childUpdate.open();
           this.$refs.childTable.defaultGetData(this.queryData);
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        let url = model.id?URL.pushMsgConfig.edit:URL.pushMsgConfig.save;
        this.dataChanage(url,model,res => {
          if (res.code == 0){
            this.$refs.childTable.defaultGetData(this.queryData);
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
              { title: window.$t("crs.pushMsg.parent"), field: 'parent',type:2,optionList:channel,isNumber:true},
              { title: 'id', field: 'id',hidden:true},
              { title: window.$t("crs.pushMsg.appKey"), field: 'appKey'},
              { title: window.$t("crs.pushMsg.appSecret"), field: 'appSecret'},
              { title: window.$t("crs.pushMsg.appName"), field: 'appName'},
              { title: window.$t("crs.pushMsg.status"), field: 'status',type:2,optionList:status,isNumber:true},
              { title: window.$t("crs.pushMsg.remark"), field: 'remark'},
          ]
        },
        /*from查询表单*/
        formData:{
          cols:[
              {click:window.$t("common.search"),auth:"sys:pushMsgConfig:find"},
              {click:window.$t("common.addNew"),auth:"sys:pushMsgConfig:save"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.pushMsgConfig.query, //请求路径和参数
          selection: true,
          sequence: true,
          isPage: false,
          cols: [
              { title: window.$t("crs.pushMsg.appKey"), field: 'appKey'},
              { title: window.$t("crs.pushMsg.appSecret"), field: 'appSecret'},
              { title: window.$t("crs.pushMsg.appName"), field: 'appName'},
              { title: window.$t("crs.pushMsg.parent"), field: 'parent'},
              { title: window.$t("crs.pushMsg.status"), field: 'status',render:(data,full)=>{
                  return status[data];
                  }},
              { title: window.$t("crs.pushMsg.remark"), field: 'remark'},
              { title: window.$t("crs.pushMsg.createTime"), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t("crs.pushMsg.updateTime"), field: 'updateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t("crs.pushMsg.updater"), field: 'updater'},
              {title:window.$t("common.handle"),btnClick:[{name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:pushMsgConfig:delete"},{name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:pushMsgConfig:edit"}]},

          ]
        }
      }
    }
  }
</script>
